import { useSettings } from 'connectors/Settings/Settings';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import useTranslation from 'next-translate/useTranslation';
import { ProductPriceType } from 'types/price';

type PromotionDurationType = 'from' | 'to';

interface PromotionDurationProps {
    price: ProductPriceType;
}

const testIdentifier = 'pages-productdetail-addtocart-promotionduration';

export const PromotionDuration = ({ price }: PromotionDurationProps) => {
    const { t } = useTranslation();
    const domainConfig = useDomainConfig();
    const settings = useSettings();

    const getFormattedDate = (type: PromotionDurationType, date: Date | null) => {
        const baseDate = new Date();

        const finalDate = date
            ? date
            : type === 'from'
              ? new Date(baseDate.getFullYear(), baseDate.getMonth(), 1)
              : new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);

        return finalDate.toLocaleDateString(
            domainConfig.defaultLocaleIdentifier,
            date ? { timeZone: domainConfig.defaultTimezone } : {},
        );
    };

    if (!settings?.displayPromotionDuration) {
        return <></>;
    }

    return (
        <div className="text-small leading-6" data-testid={testIdentifier}>
            {t(`Promotion valid from {{ validFrom }} to {{ validTo }}`, {
                validFrom: getFormattedDate('from', price.validFrom),
                validTo: getFormattedDate('to', price.validTo),
            })}
        </div>
    );
};
